import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-labeled-slider',
    templateUrl: './labeled-slider.component.html',
    styleUrls: ['./labeled-slider.component.scss']
})
export class LabeledSliderComponent {
    private _maxValue: number = 1;
    private _value: number = 1;
    private _requestedValue: number = 1;

    constructor(private readonly cdr: ChangeDetectorRef) {}

    @Input()
    set maxValue(value: number) {
        const nextMaxValue = this.normalizeNumber(value, 1);

        if (nextMaxValue === this._maxValue) {
            return;
        }

        this._maxValue = nextMaxValue;
        this.syncValueWithMax();
    }

    get maxValue(): number {
        return this._maxValue;
    }

    @Input()
    set value(value: number) {
        const nextRequestedValue = this.normalizeNumber(value, 1);

        if (nextRequestedValue === this._requestedValue) {
            return;
        }

        this._requestedValue = nextRequestedValue;
        this.syncValueWithMax();
    }

    get value(): number {
        return this._value;
    }

    @Input()
    disabled: boolean = false;

    @Input()
    title: string = '';

    @Output() valueChanged = new EventEmitter<number>();

    safeValue(value: number | null) {
        if (!value) {
            return 1;
        }

        return value;
    }

    emitNewValue(value: number) {
        this.value = value;
        this.valueChanged.next(this._value);
    }

    handleThumbInput(event: Event) {
        const target = event.target as HTMLInputElement | null;
        const nextValue = target?.valueAsNumber;

        if (typeof nextValue !== 'number' || Number.isNaN(nextValue)) {
            return;
        }

        this.emitNewValue(nextValue);
    }

    private syncValueWithMax() {
        const nextValue = this.clamp(this._requestedValue, 1, this._maxValue);

        if (nextValue === this._value) {
            return;
        }

        this._value = nextValue;
        this.cdr.markForCheck();
    }

    private normalizeNumber(value: number | null | undefined, fallback: number): number {
        if (typeof value !== 'number' || Number.isNaN(value)) {
            return fallback;
        }

        return value;
    }

    private clamp(value: number, min: number, max: number): number {
        if (max < min) {
            return min;
        }

        return Math.min(Math.max(value, min), max);
    }
}
